/**
 * DhiLogo.js — dhi Hospitality logo component
 * Single source of truth. Import and use everywhere.
 *
 * Props:
 *   variant  — "dark" (default) | "white"
 *              dark  = black logo → use on white/light backgrounds
 *              white = white logo → use on navy/dark backgrounds
 *   height   — number in px, default 28
 *   style    — optional extra inline styles
 *
 * Examples:
 *   <DhiLogo />                          nav, form card, email header
 *   <DhiLogo variant="white" />          dashboard footer, dark sections
 *   <DhiLogo height={34} />              larger nav
 *   <DhiLogo variant="white" height={26} />  dashboard topbar
 */

const LOGO_URL = "https://cdn.prod.website-files.com/686e2126992edd7b040ec218/69b4f893406935517896aa07_logo.avif";

export default function DhiLogo({ variant = "dark", height = 28, style = {} }) {
  return (
    <img
      src={LOGO_URL}
      alt="dhi Hospitality"
      height={height}
      style={{
        display: "block",
        width: "auto",
        height: `${height}px`,
        ...(variant === "white" ? {
          filter: "brightness(0) invert(1)",
        } : {}),
        ...style,
      }}
    />
  );
}
